import React from 'react';

const PrivacyPolicyTranslateAI = () => {
  const containerStyle = {
    padding: '20px',
    marginTop: '60px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  };

  const headerStyle = {
    color: '#111',
  };

  const paragraphStyle = {
    color: '#333',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

  const linkHoverStyle = {
    textDecoration: 'underline',
  };

  return (
    <div style={containerStyle}>
        <h1 style={headerStyle}>Privacy Policy</h1>
        <p style={paragraphStyle}><strong>Effective Date:</strong> 14.03.2025</p>

        <p style={paragraphStyle}>At Translate AI: Learn Language, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share your data when you use our App.</p>

        <h2 style={headerStyle}>1. Data Collection</h2>
        <p style={paragraphStyle}>We do not collect any personal data directly. However, the App integrates with third-party services that may collect data:</p>
        <ul>
            <li style={paragraphStyle}><strong>Firebase:</strong> For analytics, authentication, functions and performance monitoring.</li>
            <li style={paragraphStyle}><strong>RevenueCat:</strong> For subscription and in-app purchase management.</li>
        </ul>
        <p style={paragraphStyle}>These services may collect data such as:</p>
        <ul>
            <li style={paragraphStyle}>Device information</li>
            <li style={paragraphStyle}>Usage statistics</li>
            <li style={paragraphStyle}>Subscription details</li>
        </ul>
        <p style={paragraphStyle}>Please refer to their privacy policies for more details.</p>

        <h2 style={headerStyle}>2. Use of Data</h2>
        <p style={paragraphStyle}>Data collected by third-party services is used to:</p>
        <ul>
            <li style={paragraphStyle}>Improve app performance and user experience.</li>
            <li style={paragraphStyle}>Manage subscriptions and purchases.</li>
        </ul>

        <h2 style={headerStyle}>3. Data Sharing</h2>
        <p style={paragraphStyle}>We do not share your personal data with any other third parties. Data collected by Firebase and RevenueCat is managed according to their privacy policies.</p>

        <h2 style={headerStyle}>4. Data Security</h2>
        <p style={paragraphStyle}>We take reasonable measures to protect your data from unauthorized access, but we cannot guarantee absolute security due to the inherent risks of digital data transmission.</p>

        <h2 style={headerStyle}>5. Changes to this Policy</h2>
        <p style={paragraphStyle}>We may update this Privacy Policy from time to time. Significant changes will be communicated through the App or our website.</p>

        <h2 style={headerStyle}>6. Contact Us</h2>
        <p style={paragraphStyle}>If you have any questions about this Privacy Policy, please contact us at <a style={linkStyle} href="mailto:reecomgamestudio@gmail.com">reecomgamestudio@gmail.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicyTranslateAI;
